module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('article', {
    staticClass: "room"
  }, [_c('figure', [(_vm.room.price) ? _c('div', {
    staticClass: "price"
  }, [_vm._v(" $" + _vm._s(_vm.room.price || 0) + " "), _c('span', [_vm._v("/ "), _c('span', {
    directives: [{
      name: "lang",
      rawName: "v-lang.night",
      modifiers: {
        "night": true
      }
    }]
  })])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "hover_effect h_blue h_link",
    attrs: {
      "to": '/site/room/' + _vm.room.id
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.image,
      "alt": "Image"
    }
  })]), _vm._v(" "), _c('figcaption', [_c('h4', [_c('router-link', {
    attrs: {
      "to": '/site/room/' + _vm.room.id
    }
  }, [_vm._v(_vm._s(_vm.room.name[_vm.currentLanguage]))])], 1), _vm._v(" "), _c('span', {
    staticClass: "f_right"
  }, [_c('router-link', {
    directives: [{
      name: "lang",
      rawName: "v-lang.view_details",
      modifiers: {
        "view_details": true
      }
    }],
    staticClass: "button btn_sm btn_blue uppercase",
    attrs: {
      "to": '/site/room/' + _vm.room.id
    }
  })], 1)])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44e35ab1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/favoriteRoom/favoriteRoom.vue
// module id = 363
// module chunks = 0